import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block2-政策新闻图.png")